module.exports = __webpack_public_path__ + "static/media/HPM_video3.05f8a295.mp4";